export const REDIRECT_CANDIDATE_TYPE_PROPERTY_NAME: string = "To";
export const REDIRECT_CANDIDATE_TYPE_PROPERTY_LABEL: string = "Redirect Candidate Type";
export const QUERY_STRING_PROPERTY_NAME: string = "Query String";


// WEBPACK FOOTER //
// ./source/ts/constants/redirect.ts